import { CONTACT_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { useCardContextValue } from '../state/CardContext';
import ContactLabel from './ContactLabel';
import InlineEditableRecordLabel from './InlineEditableRecordLabel';
import { jsx as _jsx } from "react/jsx-runtime";
const RecordLabel = ({
  isEditable = true
}) => {
  const {
    objectTypeId
  } = useCardContextValue();
  return /*#__PURE__*/_jsx("div", {
    "data-test-id": "record-label",
    "data-selenium-test": "highlightTitle",
    children: objectTypeId === CONTACT_TYPE_ID ? /*#__PURE__*/_jsx(ContactLabel, {
      isEditable: isEditable
    }) : /*#__PURE__*/_jsx(InlineEditableRecordLabel, {
      isEditable: isEditable
    })
  });
};
export default RecordLabel;